"use client";

import React from "react";
import SideRailImage from "../SideRailImage";
import { PartialPartner } from "@/common/partner/types";
import useTranslations from "@/i18n/useTranslations";

type SideRailImageTitleProps = {
  title?: string;
  partners: PartialPartner[];
  sideRailImageTitle?: { isDarkMode?: boolean; isHorizontal?: boolean };
};

const SideRailImageTitle = ({
  title,
  partners,
  sideRailImageTitle,
}: SideRailImageTitleProps) => {
  const t = useTranslations("Program");
  const { isDarkMode, isHorizontal } = sideRailImageTitle || {};
  const partner = partners[0]?.name;
  const resolvedTitle =
    !title || title === "What to expect" ? t("whatToExpect") : title;
  const height = isHorizontal ? 120 : 220;

  return (
    <div
      className={`p-4 border rounded-[8px] shadow w-full max-w-md mx-auto ${
        isDarkMode ? "bg-primary" : "bg-white"
      }`}
    >
      <p
        className={`text-xl font-extrabold italic ${isDarkMode ? "text-white" : "text-primary"}`}
      >
        {resolvedTitle}
      </p>
      <div
        className={`flex gap-4 ${
          isHorizontal ? "flex-row items-center" : "flex-col items-start"
        }`}
      >
        <div className={isHorizontal ? "basis-1/2" : "w-full"}>
          <p
            className={`text-md ${isDarkMode ? "text-white" : "text-primary"}`}
          >
            {t.rich("sideRailUnlimitedAccess", {
              unlimited: (chunks) => <strong>{chunks}</strong>,
              materials: (chunks) => <strong>{chunks}</strong>,
              assignments: (chunks) => <strong>{chunks}</strong>,
              certificate: (chunks) => <strong>{chunks}</strong>,
            })}
            {partner ? t("sideRailFromPartner", { partner }) : ""}
          </p>
        </div>
        <div className={isHorizontal ? "basis-1/2" : "w-full"}>
          <SideRailImage height={height} />
        </div>
      </div>
    </div>
  );
};

export default SideRailImageTitle;
